// @ts-nocheck
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import {
  CalendarDays,
  CircleUserRound,
  Home,
  Info,
  KeyRound,
  LogOut,
  Menu,
  Phone,
  User,
} from "lucide-react";
import { Button } from "../ui/button";
import { Link, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import { useToast } from "@/components/hooks/use-toast";
import { useStore } from "@/lib/userDetails/UserDetails";
import logo1 from "@/assets/logo2.png";
import { HashLink } from "react-router-hash-link";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
//@ts-ignore
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const MobileNav = () => {
  const { toast } = useToast();
  const token = Cookies.get("token");
  const { user } = useStore();
  const navigate = useNavigate();
  const logoutHandler = () => {
    try {
      Cookies.remove("token");

      toast({
        title: "You're Logged Out Successfully!",
        description: "You have been logged out.",
        duration: 5000,
      });
      navigate("/");
    } catch (error) {
      toast({
        title: "Logout Failed",
        description: "An error occurred while logging out.",
        duration: 5000,
      });
      navigate("/");
    }
  };

  return (
    <header
      className={`md:hidden py-1 mt-11 fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white `}
    >
      <div className="container mx-auto px-4 py-2">
        <nav className="flex items-center justify-between">
          <Link to="/" className="w-20 flex items-center ">
            <img
              src={logo1}
              alt="Logo"
              className="w-full h-full object-cover"
              width={40}
              height={40}
            />
            {/* <span className="font-bold text-lg">YourBrand</span> */}
          </Link>
          <div className="flex items-center  space-x-4">
            {token && (
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="ghost"
                    className="relative h-8 w-8 rounded-full"
                  >
                    <Avatar className="h-8 w-8">
                      <AvatarImage
                        //@ts-ignore
                        src={`https://champapi.wetap.in/images/profile/${user?.profileImage}`}
                      />
                      <AvatarFallback>
                        <div className=" bg-gray-200 w-12 h-12 rounded-full text-black font-semibold flex items-center justify-center">
                          {user?.name && user?.name[0]?.toUpperCase()}
                        </div>
                      </AvatarFallback>
                    </Avatar>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-56" align="end" forceMount>
                  <div className="grid gap-4">
                    <div className="space-y-2">
                      <h4 className="font-medium leading-none">{user?.name}</h4>
                      {/* <p className="text-sm text-muted-foreground">
                        {user?.email}
                      </p> */}
                    </div>
                    <div className="grid gap-3">
                      <Link
                        to="/my-profile"
                        className="flex items-center space-x-2"
                      >
                        <User className="w-4 h-4" />
                        <span>Profile</span>
                      </Link>
                      <Link
                        to="/my-registration"
                        className="flex items-center space-x-2"
                      >
                        <CalendarDays className="w-4 h-4" />
                        <span>My Registrations</span>
                      </Link>
                      <div
                        onClick={() => {
                          navigate("/change-password");
                        }}
                        className="flex items-center gap-2 cursor-pointer"
                      >
                        <KeyRound size={17} />
                        Change Password
                      </div>
                      <div
                        onClick={logoutHandler}
                        className="flex items-center gap-2 cursor-pointer text-red-500 "
                      >
                        <LogOut size={17} /> Logout{" "}
                      </div>
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            )}
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="h-8 w-8">
                  <Menu className="h-5 w-5" />
                  <span className="sr-only">Toggle menu</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                <SheetHeader>
                  <SheetTitle>Menu</SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col space-y-4 mt-8">
                  <SheetClose asChild>
                    <Link
                      to="/"
                      className="flex items-center space-x-2 text-lg"
                    >
                      <Home className="w-5 h-5" />
                      <span>Home</span>
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <HashLink
                      smooth
                      to="/#about-us"
                      className="flex items-center space-x-2 text-lg"
                    >
                      <Info className="w-5 h-5" />
                      <span>About Us</span>
                    </HashLink>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      to="/all-events"
                      className="flex items-center space-x-2 text-lg"
                    >
                      <CircleUserRound className="w-5 h-5" />
                      <span>Events</span>
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      to="/contact-us"
                      className="flex items-center space-x-2 text-lg"
                    >
                      <Phone className="w-5 h-5" />
                      <span>Contact Us</span>
                    </Link>
                  </SheetClose>
                </nav>
                {!token && (
                  <div className="flex flex-col space-y-2 mt-8">
                    <SheetClose asChild>
                      <Button asChild className="w-full">
                        <Link to="/auth/login/email">Login</Link>
                      </Button>
                    </SheetClose>
                    <SheetClose asChild>
                      <Button asChild variant="outline" className="w-full">
                        <Link to="/auth/signup">Sign up</Link>
                      </Button>
                    </SheetClose>
                  </div>
                )}
              </SheetContent>
            </Sheet>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default MobileNav;
